<div class="row mt-2 no-gutters">
	<div class="col">
		<!-- <small>
            <a [routerLink]="['/rental-fleet']" class="text-secondary">Admin Console </a>
            /<a [routerLink]="['/support']" class="text-secondary"> Support </a>
        </small> -->
		<small *ngIf="accountCategory== 'RENTAL_FLEET' && isAdmin"><a [routerLink]="['/rental-fleet']"
				class="text-secondary">Admin
				Console </a>
			/<a [routerLink]="['/support']" class="text-secondary"> Support </a>
		</small>
		<small *ngIf="accountCategory== 'RENTAL_FLEET' && isDeveloper">
			<a [routerLink]="['/rental-fleet']" class="text-secondary">Developer Portal</a>
			/<a [routerLink]="['/support']" class="text-secondary"> Support </a>
		</small>
		<small *ngIf="(accountCategory== 'FLEET_MANAGEMENT_COMPANY' || accountCategory == 'MOBILITY_COMPANY' || accountCategory == 'FIELD_SERVICE_COMPANY') && isAdmin"><a [routerLink]="['/commercial-fleet']"
				class="text-secondary">Admin Console </a>
			/<a [routerLink]="['/support']" class="text-secondary"> Support </a>
		</small>
		<small *ngIf="(accountCategory== 'FLEET_MANAGEMENT_COMPANY' || accountCategory == 'MOBILITY_COMPANY' || accountCategory == 'FIELD_SERVICE_COMPANY') && isDeveloper">
			<a [routerLink]="['/rental-fleet']" class="text-secondary">Developer Portal</a>
			/<a [routerLink]="['/support']" class="text-secondary"> Support </a>
		</small>
		<small *ngIf="accountType== 'VEHICLE_SERVICE_PROVIDER' && isAdmin"><a [routerLink]="['/service-provider/dashboard']"
			class="text-secondary">Admin Console </a>
			/<a [routerLink]="['/support']" class="text-secondary"> Support </a>
		</small>
		<small *ngIf="accountType== 'VEHICLE_SERVICE_PROVIDER' && isDeveloper">
			<a [routerLink]="['/service-provider/dashboard']" class="text-secondary">Developer Portal</a>
			/<a [routerLink]="['/support']" class="text-secondary"> Support </a>
		</small>
		<small *ngIf="accountCategory== 'DEALER' && isAdmin"><a [routerLink]="['/dealer']"
			class="text-secondary">Admin Console </a>
			/<a [routerLink]="['/support']" class="text-secondary"> Support </a>
		</small>
		<small *ngIf="(accountCategory== 'CORPORATE' || accountCategory == 'FINANCING_GROUP') && isAdmin"><a [routerLink]="['/corporate']"
			class="text-secondary">Admin Console </a>
			/<a [routerLink]="['/support']" class="text-secondary"> Support </a>
		</small>
		<!-- <small *ngIf="accountCategory== 'DEALER' && isDeveloper">
			<a [routerLink]="['/dealer']" class="text-secondary">Developer Portal</a>
			/<a [routerLink]="['/support']" class="text-secondary"> Support </a>
		</small> -->
	</div>
</div>

<div class="row pb-5 pt-2 no-gutters">
	<div class="col-sm-12">
		<button class="btn btn-primary float-right border" data-toggle="modal"
			(click)="setDefaultPriority()" data-target="#submitTicket" data-backdrop="static"
			data-keyboard="false">Submit Ticket
			<!-- &nbsp;<span><i class="fas fa-chevron-right"></i></span> -->
		</button>
	</div>

	<ng-container *ngIf="masterTicketList && masterTicketList.length > 0 else noTickets">
		<div class="table-responsive col-sm-12 mt-4">
			<table class="table table-striped tbl-scrollable">
				<thead class="thead-light cursor-pointer">
					<tr>
						<!-- <th scope="col">&nbsp;</th> -->
						<th scope="col" width="10%"></th>
						<th scope="col" width="10%" class="pl-3">Ticket Id</th>
						<th scope="col" width="25%">Subject</th>
						<!-- <th scope="col" width="33%">Description</th> -->
						<th scope="col" width="16%">
							<select (change)="onRequestCategoryFilter($event.target.value)">
								<option>Request Category</option>
								<option>All</option>
								<option *ngFor="let item of requestCategoryFilterOption;">
									{{item}}
								</option>
							</select>
						</th>
						<th scope="col" width="10%">
							<select (change)="onPriorityFilter($event.target.value)">
								<option>Priority</option>
								<option>All</option>
								<option *ngFor="let item of priorityFilterOption;">
									{{item}}
								</option>
							</select>
						</th>
						<th scope="col" width="16%">
							<select (change)="onStatusFilter($event.target.value)">
								<option>Status</option>
								<option>All</option>
								<option *ngFor="let item of statusFilterOptions;">
									{{item}}
								</option>
							</select>
						</th>
						<th scope="col" width="13%" (click)="onSortByDateClick()"><span
								class="float-right">Date&nbsp;&nbsp;<i *ngIf="selectedDateSortType == null"
									class="fa fa-unsorted" aria-hidden="true"></i><i
									*ngIf="selectedDateSortType == sortType[0]" class="fa fa-sort-down"
									aria-hidden="true"></i><i *ngIf="selectedDateSortType == sortType[1]"
									class="fa fa-sort-up" aria-hidden="true"></i></span></th>
						<!-- <th scope="col" (click)="onSortByStatusClick()">Status&nbsp;&nbsp;<i *ngIf="selectedStatusSortType == null" class="fa fa-unsorted" aria-hidden="true"></i><i *ngIf="selectedStatusSortType == sortType[0]" class="fa fa-sort-down" aria-hidden="true"></i><i *ngIf="selectedStatusSortType == sortType[1]" class="fa fa-sort-up" aria-hidden="true"></i></th> -->
						<!-- <th scope="col" width="20%">
							<select  (change)="filterTickets($event.target.value)">
								<option *ngFor="let item of ticketStatus;" value="{{item}}">
									{{item}}
								</option>
							</select>
						</th>
						<th scope="col" width="17%" (click)="onSortBySeverityClick()">Business Impact&nbsp;&nbsp;<i
								*ngIf="selectedSeveritySortType == null" class="fa fa-unsorted" aria-hidden="true"></i><i
								*ngIf="selectedSeveritySortType == sortType[0]" class="fa fa-sort-down" aria-hidden="true"></i><i
								*ngIf="selectedSeveritySortType == sortType[1]" class="fa fa-sort-up" aria-hidden="true"></i></th> -->
					</tr>
				</thead>
				<tbody class="max-height-57">
					<!-- <ng-container *ngFor="let ticket of tickets; let i = index">
						<tr class="cursor-pointer font-14" *ngIf="apiService.accountDetail.id == ticket.fleet"
							[routerLink]="['/ticket-detail']" [queryParams]="{ticketId: ticket.ticketNo}"> -->
					<!-- <td class="text-center">
															<img class="ticket-img" *ngIf="ticket.assignee == null" src="assets/images/circle.png">
															<img class="ticket-img" *ngIf="ticket.assignee != null && ticket.assignee.image == null"
																	src="assets/images/user_male.png">
															<img class="ticket-img" *ngIf="ticket.assignee != null && ticket.assignee.image"
																	[src]="ticket.assignee.image"><br>
															<small
																	*ngIf="ticket.assignee != null && ticket.assignee.name">{{ticket.assignee.name}}</small>
													</td> -->
					<!-- <td class="pl-3">{{ticket.ticketNo}}</td>
							<td>{{ticket.subject}}</td>
							<td data-toggle="tooltip" data-placement="top"
								title="{{ticket.date | date:'MM/dd/y h:mm:ss a'}}">{{ticket.date | timeAgo}}</td>
							<td class="pl-3">{{ticket.status}}</td>
							<td>{{ticket.businessImpact}}</td>
						</tr>
					</ng-container> -->
					<ng-container *ngFor="let ticket of tickets; let i = index">
						<tr class="cursor-pointer font-14" [routerLink]="['/ticket-detail']"
							[queryParams]="{ticketIndex: ticket.index, supportUserId: supportUser.supportUserId, serviceDesk: getServiceDeskForIssue(ticket.serviceDeskId), statusColor: getStatusColor(ticket.currentStatus.status)}">
							<td width="10%">
								<div class="text-center">
									<div><img class="ticket-img-4" src="assets/images/user_male.png"></div>
									<div><small class="font10-400">{{ticket.reporter.displayName}}</small></div>
								</div>
							</td>
							<td width="10%" class="pl-3">{{ticket.issueKey}}</td>
							<td width="25%">{{getRequestFieldValue(ticket, 'summary')}}</td>
							<!-- <td class="text-truncate" style="max-width: 0px;">{{ticket.requestFieldValues[1].value}}</td> -->
							<!-- <td>{{ticket.reporter.displayName}}</td> -->
							<td width="16%">{{getRequestCategoryName(ticket.requestTypeId)}}</td>
							<td width="10%">
								<img class="height-16" [src]="ticket.priority.iconUrl" alt="">
								<span>{{ticket.priority.name}}</span>
								<!-- <span [style.color]="ticket.priority.color">{{ticket.priority.name}}</span> -->
							</td>
							<td width="16%"><span
									[style.color]="getStatusColor(ticket.currentStatus.status)">{{ticket.currentStatus.status}}</span>
							</td>
							<td width="13%" data-toggle="tooltip" data-placement="top"
								title="{{ticket.createdDate.iso8601 | date:'MM/dd/y h:mm:ss a'}}">
								<span *ngIf="utilService.getDateDifference(ticket.createdDate.epochMillis) < 8"
									class="float-right">{{ticket.createdDate.iso8601 | timeAgo}}</span>
								<span *ngIf="utilService.getDateDifference(ticket.createdDate.epochMillis) >= 8"
									class="float-right">{{ticket.createdDate.iso8601 | date:'MM/dd/y'}}</span>
							</td>
							<!-- <td class="pl-3">{{ticket.status}}</td>
							<td>{{ticket.businessImpact}}</td> -->
						</tr>
					</ng-container>
				</tbody>
			</table>
			<!-- <div *ngIf="accountTickets == null || accountTickets == undefined || accountTickets.length == 0"
				class="col-sm-12 col-md text-center">
				<h3 class="text-muted">No Tickets Available</h3>
			</div> -->
			<!-- <div *ngIf="tickets == null || tickets == undefined || tickets.length == 0"
				class="col-sm-12 col-md text-center">
				<h3 class="text-muted">No Tickets Available</h3>
			</div> -->
		</div>

		<ng-container *ngIf="tickets && tickets.length > 0 else noTickets">
			<div class="col-sm-12 mt-2 no-gutter text-right">
				<!-- <span class="pointer" *ngIf="usagePageInfo && usagePageInfo.prev" (click)="getPreviousPage()"><< Previous</span> &nbsp;&nbsp;&nbsp;&nbsp;  -->
				<span class="pointer mr-4" *ngIf="showPreviousButton()" (click)="getPreviousIssues()">
					<< Previous</span> <span class="pointer" *ngIf="showNextButton()" (click)="getNextIssues()"> Next >>
				</span>
			</div>
		</ng-container>
	</ng-container>
	<ng-template #noTickets>
    <div class="col-12 text-center" style="margin-top: 5%;">
      <h3 class="text-muted">No Ticket Available</h3>
    </div>
  </ng-template>
</div>


<!-- Modal submit ticket -->
<div class="modal" id="submitTicket" tabindex="-1" role="dialog" aria-hidden="true" data-backdrop="static">
	<div class="modal-dialog modal-lg modal-dialog-scrollable modal-dialog-centered" role="document">
		<div class="modal-content">
			<div class="modal-header popup-header">
				<h5 class="modal-title" id="addTicketDetails">New Ticket Details</h5>
				<button id="closeTicketDetails" type="button" class="close" data-dismiss="modal" aria-label="Close">
					<span aria-hidden="true"
						(click)="resetAddTicketForm();">&times;</span>
				</button>
			</div>
			<form #addTicketDetailsForm="ngForm" novalidate (ngSubmit)="addTicketDetailsForm.form.valid">
				<div class="modal-body">
					<div class="row">
						<div class="col-12">
							<div class="form-group">
								<label for="ticketSubject"><span
										class="maroon  astrisk">&#10033;&nbsp;</span>Subject</label>
								<input type="text" class="form-control" id="ticketSubject" name="ticketSubject"
									placeholder="Subject" required [(ngModel)]="ticketFormData.subject"
									#ticketSubject="ngModel">
								<small class="text-danger text-center"
									*ngIf="ticketSubject.invalid && (ticketSubject.dirty || ticketSubject.touched)">
									<p class="mb-0" *ngIf="ticketSubject.errors.required">*Required</p>
								</small>
							</div>
						</div>
						<div class="col-12">
							<div class="form-group">
								<label for="ticketComment"><span
										class="maroon  astrisk">&#10033;&nbsp;</span>Detail</label>
								<textarea rows="4" type="text" class="form-control" id="ticketComment"
									name="ticketComment" placeholder="Detail" required
									[(ngModel)]="ticketFormData.comment" #ticketComment="ngModel"></textarea>
								<small class="text-danger text-center"
									*ngIf="ticketComment.invalid && (ticketComment.dirty || ticketComment.touched)">
									<p class="mb-0" *ngIf="ticketComment.errors.required">*Required</p>
								</small>
							</div>
						</div>
						<!-- <div *ngIf="supportUser && supportUser.serviceDesks" class="col-md-6 col-sm-12">
							<div class="form-group">
								<label for="serviceDesk"><span class="maroon  astrisk">&#10033;&nbsp;</span>Service
									Desk</label><br>
								<select id="serviceDesk" name="serviceDesk" (change)="getRequestType()"
									[(ngModel)]="ticketFormData.serviceDesk" #serviceDesk="ngModel" required>
									<option [ngValue]="null">Service Desk</option>
									<option *ngFor="let desk of supportUser.serviceDesks; let i = index;"
										[ngValue]="desk">
										{{desk.projectName}}
									</option>
								</select>
								<small class="text-danger"
									*ngIf="serviceDesk.invalid && (serviceDesk.dirty || serviceDesk.touched)">
									<p class="mb-0" *ngIf="serviceDesk.errors.required">*Required</p>
								</small>
							</div>
						</div> -->
						<div class="col-md-6 col-sm-12">
							<div class="form-group">
								<label for="requestCategory"><span class="maroon  astrisk">&#10033;&nbsp;</span>Request
									Category</label><br>
								<select id="requestCategory" name="requestCategory"
									[(ngModel)]="ticketFormData.requestCategory" #requestCategory="ngModel" required>
									<option [ngValue]="null" disabled>Category</option>
									<option *ngFor="let category of requestCategories; let i = index;"
										[ngValue]="category">
										{{category.name}}
									</option>
								</select>
								<small class="text-danger"
									*ngIf="requestCategory.invalid && (requestCategory.dirty || requestCategory.touched)">
									<p class="mb-0" *ngIf="requestCategory.errors.required">*Required</p>
								</small>
							</div>
						</div>
						<div class="col-md-6 col-sm-12">
							<div class="form-group">
								<label for="priority">Priority</label><br>
								<select id="priority" name="priority" [(ngModel)]="ticketFormData.priority">
									<option [ngValue]="null" disabled>Priority</option>
									<option *ngFor="let priority of priorities" [ngValue]="priority">
										{{priority.name}}
									</option>
								</select>
							</div>
						</div>
						<div *ngIf="requestAttachment" class="col-md-6 col-sm-12 mt-2">
							<i class="fa fa-paperclip text-muted" aria-hidden="true">Attachments</i>
							<div class="text-muted font13-400 ml-2 mt-2">{{requestAttachment.name}}</div>
						</div>
					</div>
				</div>
				<div class="modal-footer">
					<div class="mr-auto">
						<i id="openFileUpload" (click)="addAttachmentInput.click()"
							class="fa fa-paperclip text-muted pointer" aria-hidden="true" data-toggle="tooltip" title="File formats: .jpeg, .jpg, .png, .pdf, .txt, .json"></i>
						<br>
						<span class="txt-small text-muted">(File formats: .jpeg, .jpg, .png, .pdf, .txt, .json)</span>
					</div>
					<input #addAttachmentInput class="hide import-light-btn" type="file"
						accept="image/jpeg,image/png,application/pdf,text/plain,.json"
						(change)="onAttachmentSelected($event.target.files)">
					<button type="button" class="btn btn-light btn-80" data-dismiss="modal"
						(click)="resetAddTicketForm();">CANCEL</button>
					<button type="submit" class="btn btn-primary border ml-2 btn-80"
						[disabled]="addTicketDetailsForm.form.pristine || addTicketDetailsForm.form.invalid"
						data-dismiss="modal" (click)="onTicketDetailsSubmit()">Submit</button>
				</div>
			</form>
		</div>
	</div>
</div>